/* Bonvayana · mensajes al añadir mostrados en la capa superior (popover), por encima del carrito.
   Sustituye show/hide de <bv-toasts> para que el carrito no los borre al redibujarse. */
const wait = (ms) => new Promise((r) => setTimeout(r, ms));
function bubble(text) {
  const el = document.createElement('div');
  el.className = 'bv-msg bv-new';
  el.textContent = text;
  return el;
}
async function patch() {
  await customElements.whenDefined('bv-toasts');
  const Toasts = customElements.get('bv-toasts');
  Toasts.prototype.show = function (parts) {
    (this.timers || []).forEach(clearTimeout);
    this.timers = [];
    this.innerHTML = '';
    if (this.parentElement !== document.body) document.body.append(this);
    this.classList.toggle('is-drawer', !!document.querySelector('dialog[open]'));
    try { if (this.matches(':popover-open')) this.hidePopover(); this.showPopover(); } catch (e) { /* sin popover */ }
    parts.forEach((text, i) => {
      this.timers.push(setTimeout(() => {
        const t = document.createElement('div');
        t.className = 'bv-toast';
        t.innerHTML = '<span class="bv-av" aria-hidden="true">B</span>';
        t.append(bubble(text.trim()));
        t.addEventListener('click', () => this.hide());
        this.append(t);
      }, 250 + i * 1000));
    });
    this.timers.push(setTimeout(() => this.hide(), 250 + parts.length * 1000 + 3400));
  };
  Toasts.prototype.hide = function () {
    this.querySelectorAll('.bv-toast').forEach((t) => t.classList.add('is-out'));
    this.timers.push(setTimeout(() => {
      this.innerHTML = '';
      try { this.hidePopover(); } catch (e) { /* sin popover */ }
    }, 380));
  };
}
patch();
await wait(0);
